import React from 'react'
import { Link } from '@reach/router'

const numeral: any = require('numeral')
interface Concept {
    description: string;
    total: number;
}
const context = process.env.PUBLIC_URL

export default function Product({ widget }: any) {
    return (
        <div style={{ maxWidth: '600px', position: 'relative', margin: 'auto' }}>
            <div className="rounded overflow-hidden shadow-lg p-8 flex flex-col items-strech flex-3" style={{ minHeight: '800px' }}>
                <div className="px-6 py-4 grid grid-cols-1">
                    <div className="font-bold text-2xl mb-2">
                        <img src={widget.logo} alt={widget.name} style={{ margin: 'auto' }} />
                    </div>
                    <div className="text-gray-700 text-base">
                        {widget.instruccion}
                    </div>
                </div>
                {!!widget.concepts.length && widget.concepts.map((it: Concept) => <div key={it.description}>
                    <div className="px-6 py-2 text-2xl font-bold">
                        {it.description}
                    </div>
                    <div className="px-6 py-2 text-2xl font-bold">
                        <hr />
                    </div>
                    <div className="px-6 py-2">
                        <span className="text-gray-500">Precio:</span> <span className="text-2xl font-bold float-right">$ {numeral(it.total).format('0,0.00')}</span>
                    </div>
                </div>)}
                <div>
                    <div className="px-6 py-4">
                        <span className="text-2xl font-bold">
                            Total:
                        </span>
                        <span className="text-2xl font-bold float-right">$ {numeral(widget.amount).format('0,0.00')}</span>
                    </div>
                    <div className="px-6 py-4 flex flex-row" style={{ alignSelf: 'end' }}>
                        <Link to={`${context}/client?key=${widget.key}`} className="w-full text-center float-rigth bg-red-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
                            Siguiente
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
